module.exports = __webpack_public_path__ + "static/media/dishon_promo.05ad9412.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/dishon_promo.png
// module id = 72
// module chunks = 0